import React from "react";
import { TimeStatus } from "Components";
import { MemberStatus } from "Types";

const STATUS_TEXT: Record<MemberStatus, string> = {
  invited: "Invite pending",
  active: "Active",
  deactivated: "Deactivated",
};

type MemberLoginStatusProps = {
  status: MemberStatus;
  last_active: string | null;
};

const MemberLoginStatus = ({
  status,
  last_active,
}: MemberLoginStatusProps): React.JSX.Element => {
  if (status !== "active") {
    return <>{STATUS_TEXT[status]}</>;
  } else {
    if (!last_active) {
      return <>Never</>;
    } else {
      return <TimeStatus timestamp={last_active} wholeDays={true} />;
    }
  }
};

export default MemberLoginStatus;
